
import React, {useEffect, useRef} from 'react';
import './ServicesComponent.css';
import lottie from 'lottie-web';
import animationData from '../../assets/animations/programmingAnimation.json';
import animationData1 from '../../assets/animations/marketingAnimation.json';
import animationData2 from '../../assets/animations/designAnimation.json';

export const ServicesComponent = () => {

    const animContainer = useRef(null);
    const animContainer1 = useRef(null);
    const animContainer2 = useRef(null);


    useEffect(() => {
        lottie.loadAnimation({
            container: animContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData
        })
        lottie.setSpeed(0.6);
        
    }, [])

    useEffect(() => {
        lottie.loadAnimation({
            container: animContainer1.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData1
        })
        lottie.setSpeed(0.6);
        
    }, [])

    useEffect(() => {
        lottie.loadAnimation({
            container: animContainer2.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData2
        })
        lottie.setSpeed(0.6);
        
    }, [])


    return (
        <div id='serviciosC'>
        <div className='serviceMain'>
            <h1>Descubre Nuestros Servicios</h1>
            <div className='servicesBlockMainContainer'>
                <div className="servicesBlockMainItem">
                <div className='container' ref={animContainer} style={{ width: '100%', height: 'auto', maxWidth: '200px', margin: '0 auto' }}></div>
                    <h2>Desarrollo Web</h2>
                    <p>
                    Creando sitios web seguros y fáciles de usar para impulsar tu presencia y crecimiento en línea.
                    </p>
                    
                </div>
                <div className="servicesBlockMainItem">
                <div className='container' ref={animContainer1} style={{ width: '100%', height: 'auto', maxWidth: '200px', margin: '0 auto' }}></div>
                    <h2>Diseño de Identidad</h2>
                    <p>
                    Forjamos una identidad única que cautiva a tu audiencia, capturando la esencia de tu empresa.
                    </p>
                    
                </div>
                <div className="servicesBlockMainItem">
                <div className='container' ref={animContainer2} style={{ width: '100%', height: 'auto', maxWidth: '200px', margin: '0 auto' }}></div>
                    <h2>Diseño Gráfico</h2>
                    <p>
                    Destaca con un diseño que comunica tu mensaje y proyecta una imagen atractiva en el mundo digital.
                    </p>
                    
                </div>
            </div>
        </div>
        </div>
    )
}
